import { render } from "./RegisterFacebookPage.vue?vue&type=template&id=56f942b3"
import script from "./RegisterFacebookPage.vue?vue&type=script&lang=js"
export * from "./RegisterFacebookPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__